import React from 'react';
import Input from '../../../components/ui/Input';
import Icon from '../../../components/AppIcon';

const PersonalInfoForm = ({ formData, errors, onChange }) => {
  const handleChange = (e) => {
    const { name, value } = e?.target;
    onChange({ ...formData, [name]: value });
  };

  return (
    <div className="bg-card rounded-xl p-6 md:p-8 shadow-md border border-border">
      <div className="flex items-center gap-3 mb-6">
        <div className="w-10 h-10 rounded-lg bg-primary/10 flex items-center justify-center">
          <Icon name="User" size={20} color="var(--color-primary)" />
        </div>
        <h2 className="text-xl md:text-2xl font-heading font-semibold text-foreground">
          Personal Information
        </h2>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-6">
        <Input
          label="First Name"
          type="text"
          name="firstName"
          placeholder="Enter your first name"
          value={formData?.firstName}
          onChange={handleChange}
          error={errors?.firstName}
          required
        />

        <Input
          label="Last Name"
          type="text"
          name="lastName"
          placeholder="Enter your last name"
          value={formData?.lastName}
          onChange={handleChange}
          error={errors?.lastName}
          required
        />

        <Input
          label="Email Address"
          type="email"
          name="email"
          placeholder="your.email@example.com"
          value={formData?.email}
          onChange={handleChange}
          error={errors?.email}
          description="We'll send your membership details here"
          required
        />

        <Input
          label="Phone Number"
          type="tel"
          name="phone"
          placeholder="(555) 123-4567"
          value={formData?.phone}
          onChange={handleChange}
          error={errors?.phone}
          required
        />

        <Input
          label="Date of Birth"
          type="date"
          name="dateOfBirth"
          value={formData?.dateOfBirth}
          onChange={handleChange}
          error={errors?.dateOfBirth}
          required
        />

        <Input
          label="Gender"
          type="text"
          name="gender"
          placeholder="Male/Female/Other"
          value={formData?.gender}
          onChange={handleChange}
        />
      </div>
      <div className="mt-6 md:mt-8 pt-6 md:pt-8 border-t border-border">
        <h3 className="text-lg font-heading font-semibold text-foreground mb-4 md:mb-6">
          Emergency Contact
        </h3>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-6">
          <Input
            label="Contact Name"
            type="text"
            name="emergencyName"
            placeholder="Full name"
            value={formData?.emergencyName}
            onChange={handleChange}
            error={errors?.emergencyName}
            required
          />

          <Input
            label="Contact Phone"
            type="tel"
            name="emergencyPhone"
            placeholder="(555) 123-4567"
            value={formData?.emergencyPhone}
            onChange={handleChange}
            error={errors?.emergencyPhone}
            required
          />

          <Input
            label="Relationship"
            type="text"
            name="emergencyRelationship"
            placeholder="e.g., Spouse, Parent, Sibling"
            value={formData?.emergencyRelationship}
            onChange={handleChange}
          />
        </div>
      </div>
      <div className="mt-6 md:mt-8">
        <Input
          label="Address"
          type="text"
          name="address"
          placeholder="Street address"
          value={formData?.address}
          onChange={handleChange}
          className="mb-4"
        />
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
          <Input
            label="City"
            type="text"
            name="city"
            placeholder="City"
            value={formData?.city}
            onChange={handleChange}
          />
          <Input
            label="State"
            type="text"
            name="state"
            placeholder="State"
            value={formData?.state}
            onChange={handleChange}
          />
          <Input
            label="ZIP Code"
            type="text"
            name="zipCode"
            placeholder="12345"
            value={formData?.zipCode}
            onChange={handleChange}
          />
        </div>
      </div>
    </div>
  );
};

export default PersonalInfoForm;